// needs a separate module as this is required inside chevrotain productive code
// and also in the entry point for webpack(api.ts).
// A separate file avoids cyclic dependencies and webpack errors.
export var VERSION = "7.1.2";
//# sourceMappingURL=version.js.map